import React, { useState } from 'react';
import { Section } from './ui/Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, CheckCircle2 } from 'lucide-react';
export default function ObjectionsSection() {
  const faqs = [{
    q: '«Ya compré planners y no los usé.»',
    a: 'Esto no te pide inventar ni motivarte. Te da defaults.'
  }, {
    q: '«Mi semana cambia todo el tiempo.»',
    a: 'Por eso existe 12-3-2: comodines + emergencias. No es rígido.'
  }, {
    q: '«No tengo tiempo.»',
    a: 'No te estoy pidiendo tiempo diario. Te pido 10 minutos para dejar de perder 45.'
  }, {
    q: '«¿Y si me aburro?»',
    a: 'Rotación cada 4-8 semanas: cambias 1-3 comidas, no todo.'
  }, {
    q: '«¿Necesito cocinar mucho el domingo?»',
    a: 'No. Esto no es solo Meal Prep. Es un sistema de decisión. Tú eliges si cocinas en el momento o por adelantado, el sistema te quita la fatiga mental de elegir qué.'
  }, {
    q: '«¿Funciona para familias exigentes?»',
    a: 'Sí, porque la Lista Maestra la armas tú con tus «comidas ganadoras». El sistema solo organiza tu biblioteca personal.'
  }, {
    q: '«¿Cómo sé que esto funciona?»',
    a: 'Porque no depende de tu motivación. Depende de un sistema. Y los sistemas no necesitan que estés de humor para funcionar.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section className="bg-brand-cream-dark" data-id="element-221">
      <h2 className="font-heading text-4xl text-slate-900 text-center mb-12 uppercase tracking-wide" data-id="element-222">
        Tal vez estás pensando…
      </h2>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-223">
        {faqs.map((faq, index) => <div key={index} className="border border-brand-brown/15 rounded-lg overflow-hidden bg-white shadow-sm group hover:border-brand-purple/30 transition-colors" data-id="element-224">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none hover:bg-slate-50 transition-colors" data-id="element-225">
              <span className="text-xl font-medium text-slate-800 pr-4 group-hover:text-slate-900 transition-colors" data-id="element-226">
                {faq.q}
              </span>
              <ChevronDown className={`text-brand-brown transition-transform duration-200 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-227" />
            </button>
            <AnimatePresence data-id="element-228">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.2
          }} data-id="element-229">
                  <div className="p-6 pt-0 text-lg text-slate-600 border-t border-slate-100 leading-relaxed flex gap-4" data-id="element-230">
                    <CheckCircle2 className="text-brand-purple flex-shrink-0 mt-1" size={20} data-id="element-231" />
                    <span data-id="element-232">{faq.a}</span>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}